/* eslint-disable */
import { useState } from "react";
import { Link } from "react-router-dom";
import { toast, Toaster } from "sonner";
import api from "../lib/api";

const CATEGORIES = [
  { key: "general",  label: "General question" },
  { key: "booking",  label: "Booking issue" },
  { key: "billing",  label: "Billing / refund" },
  { key: "host",     label: "Host a workspace" },
  { key: "bug",      label: "Bug or site issue" },
  { key: "feedback", label: "Product feedback" },
];

function PublicHeader() {
  return (
    <header className="rec-topbar">
      <Link to="/spaces" className="rec-brand"><span className="rec-brand-mark"><img src="/brand/metier-icon.png" alt="Métier" /></span></Link>
      <nav className="rec-topnav">
        <Link to="/spaces">Spaces</Link>
        <Link to="/hours">Métier Hours</Link>
        <Link to="/list-your-space">List your space</Link>
        <Link to="/login" data-testid="support-signin">Member sign in</Link>
      </nav>
    </header>
  );
}

export default function Support() {
  const [form, setForm] = useState({
    name: "", email: "", subject: "", message: "", category: "general",
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(null);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.subject.trim() || !form.message.trim()) {
      toast.error("Please fill in all fields.");
      return;
    }
    setSubmitting(true);
    try {
      const { data } = await api.post("/support/tickets", form);
      setSubmitted({ ticket_id: data.ticket_id });
      toast.success("Sent, we'll be in touch soon.");
      setForm({ name: "", email: "", subject: "", message: "", category: "general" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not submit, please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="rec-page">
      <Toaster richColors position="top-center" />
      <PublicHeader />
      <main className="rec-main" style={{maxWidth:720}}>
        <span className="rec-eyebrow">Métier · Support</span>
        <h1 className="rec-h1" data-testid="support-h1">How can we <em>help</em>?</h1>
        <p className="rec-desc" style={{maxWidth:560}}>
          Drop us a note about anything, a booking, a billing question, a partnership inquiry, or just feedback. We read every message and reply within one business day.
        </p>

        {submitted ? (
          <div className="m-card" style={{padding:32, marginTop:32}} data-testid="support-submitted">
            <span className="rec-eyebrow">Ticket received</span>
            <h2 className="rec-h2" style={{margin:"8px 0 14px"}}>Thanks, message is in.</h2>
            <p className="rec-desc">Your ticket ID is <code style={{background:"rgba(184,145,58,0.12)",padding:"2px 8px",borderRadius:4,fontFamily:"monospace"}}>{submitted.ticket_id}</code>. We&apos;ll email you back at the address you provided within one business day.</p>
            <div style={{marginTop:18,display:"flex",gap:10,flexWrap:"wrap"}}>
              <button type="button" className="m-btn-gold" onClick={() => setSubmitted(null)} data-testid="support-new">Send another</button>
              <Link to="/" className="m-btn-ghost">Back to Métier</Link>
            </div>
          </div>
        ) : (
          <form className="m-card" style={{padding:28, marginTop:32}} onSubmit={submit} data-testid="support-form">
            <div className="m-form-row">
              <label>Your name</label>
              <input
                value={form.name}
                onChange={set("name")}
                required
                placeholder="Camille Beauchamp"
                data-testid="support-name"
              />
            </div>
            <div className="m-form-row">
              <label>Email</label>
              <input
                type="email"
                value={form.email}
                onChange={set("email")}
                required
                placeholder="you@example.com"
                data-testid="support-email"
              />
            </div>
            <div className="m-form-row">
              <label>Topic</label>
              <select value={form.category} onChange={set("category")} data-testid="support-category">
                {CATEGORIES.map(c => <option key={c.key} value={c.key}>{c.label}</option>)}
              </select>
            </div>
            <div className="m-form-row">
              <label>Subject</label>
              <input
                value={form.subject}
                onChange={set("subject")}
                required
                placeholder="A short one-liner"
                data-testid="support-subject"
              />
            </div>
            <div className="m-form-row">
              <label>Message</label>
              <textarea
                value={form.message}
                onChange={set("message")}
                required
                rows={7}
                placeholder="Tell us what's going on. The more detail, the better."
                data-testid="support-message"
              />
            </div>
            <div style={{display:"flex", justifyContent:"flex-end", marginTop:18}}>
              <button type="submit" className="m-btn-gold" disabled={submitting} data-testid="support-submit">
                {submitting ? "Sending…" : "Send message →"}
              </button>
            </div>
            <p className="m-muted small" style={{marginTop:14}}>
              Or email us directly at <a href="mailto:contact@workmetier.com" style={{color:"var(--gold)"}}>contact@workmetier.com</a>.
            </p>
          </form>
        )}
      </main>
      <footer className="rec-footer">
        <span>© Métier · workmetier.app</span>
        <span><Link to="/dmv" style={{color:"var(--gold)"}}>DMV</Link> · <Link to="/nh" style={{color:"var(--gold)"}}>NH</Link> · <Link to="/ma" style={{color:"var(--gold)"}}>MA</Link></span>
      </footer>
    </div>
  );
}
